'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getIsLineEndSnapped = exports.getIsLineStartSnapped = exports.getLineEndStyle = exports.getLineStartStyle = exports.makeGetEdgesPx = exports.makeGetLineEdgeDetails = exports.getControlPosition = exports.getEndConnectedElementId = exports.getStartConnectedElementId = exports.getLineControl = undefined;

var _fp = require('lodash/fp');

var _Vector = require('../../../common/maths/geometry/Vector');

var _Vector2 = _interopRequireDefault(_Vector);

var _milanoteReselect = require('../../utils/milanoteReselect/milanoteReselect');

var _gridSizeSelector = require('../../utils/grid/gridSizeSelector');

var _lineUtil = require('./lineUtil');

var _elementHelper = require('../../../common/elements/elementHelper');

var _elementSelector = require('../elementSelector');

var _elementPositionSelector = require('../elementPositionSelector');

var _measurementsSelector = require('../../components/measurements/measurementsSelector');

var _lineConstants = require('../../../common/lines/lineConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Selectors


// Utils
/* eslint-disable */
// Lib
var getLineEdge = function getLineEdge(edge) {
    return function (state, ownProps) {
        return (0, _elementSelector.getElement)(state, ownProps).getIn(['content', edge]);
    };
};

// Constants


// Geometry
var getLineControl = exports.getLineControl = function getLineControl(state, ownProps) {
    return (0, _elementSelector.getElement)(state, ownProps).getIn(['content', 'control']);
};

var getConnectedElementId = function getConnectedElementId(edge) {
    return function (state, ownProps) {
        var lineEdge = getLineEdge(edge)(state, ownProps);
        if (!lineEdge.get('snapped')) return null;
        return lineEdge.get('elementId');
    };
};

var getStartConnectedElementId = exports.getStartConnectedElementId = getConnectedElementId('start');
var getEndConnectedElementId = exports.getEndConnectedElementId = getConnectedElementId('end');

var getConnectedElement = function getConnectedElement(edge) {
    return function (state, ownProps) {
        var connectedElementId = getConnectedElementId(edge)(state, ownProps);
        if (!connectedElementId) return null;

        return (0, _elementSelector.getElements)(state, ownProps).get(connectedElementId);
    };
};

var getConnectedElementPosition = function getConnectedElementPosition(edge) {
    return function (state, ownProps) {
        var connectedElement = getConnectedElement(edge)(state, ownProps);

        if (!connectedElement) return null;

        var parentId = connectedElement.getIn(['location', 'parentId']);
        // Doubt this could happen, but just in case
        if (!parentId) return null;

        // If the parent is a column use it as the connected element
        var parent = (0, _elementSelector.getElements)(state, ownProps).get(parentId);
        if ((0, _elementHelper.isColumn)(parent)) return null;

        return connectedElement.getIn(['location', 'position']);
    };
};

var getControlPosition = exports.getControlPosition = function getControlPosition(_ref) {
    var start = _ref.start,
        end = _ref.end,
        control = _ref.control;

    var lineVector = _Vector2.default.lineVector(start, end);
    var perpindicularVector = lineVector.clone().perpendicular();

    // By default the control point is halfway along the straight line between the two points
    var controlPerpMag = control ? control.get('perpMag') : 0;
    var controlParallelRatio = control ? control.get('parallelRatio') : 0.5;

    var controlPerp = perpindicularVector.toLength(controlPerpMag);
    var controlParallel = lineVector.multiplyScalar(controlParallelRatio);

    return controlParallel.add(controlPerp).add(start);
};

var makeGetLineEdgeDetails = exports.makeGetLineEdgeDetails = function makeGetLineEdgeDetails() {
    return (0, _milanoteReselect.createShallowSelector)(
    // get start edge
    getLineEdge(_lineConstants.LINE_EDGE.start),
    // get start element position
    getConnectedElementPosition(_lineConstants.LINE_EDGE.start),
    // get end edge
    getLineEdge(_lineConstants.LINE_EDGE.end),
    // get end element position
    getConnectedElementPosition(_lineConstants.LINE_EDGE.end),
    // Get current element position
    _elementPositionSelector.getElementGridPosition,
    // TODO Return only the required measurements (the ones that the line edges require)
    // get measurements
    _measurementsSelector.getMeasurementsMapFromProps, _gridSizeSelector.getGridSize, function (startEdge, startElementPosition, endEdge, endElementPosition, lineElementPosition, measurementsMap, gridSize) {
        var startConnection = (0, _lineUtil.getEdgeOriginAndRect)({
            lineEdge: startEdge,
            measurementsMap: measurementsMap,
            connectedElementPosition: startElementPosition,
            lineElementPosition: lineElementPosition,
            gridSize: gridSize
        });
        var endConnection = (0, _lineUtil.getEdgeOriginAndRect)({
            lineEdge: endEdge,
            measurementsMap: measurementsMap,
            connectedElementPosition: endElementPosition,
            lineElementPosition: lineElementPosition,
            gridSize: gridSize
        });

        return {
            startEdgeOrigin: startConnection.origin,
            startConnectionRect: startConnection.rect,
            endEdgeOrigin: endConnection.origin,
            endConnectionRect: endConnection.rect
        };
    });
};

var makeGetEdgesPx = exports.makeGetEdgesPx = function makeGetEdgesPx() {
    return (0, _milanoteReselect.createShallowSelector)(makeGetLineEdgeDetails(),
    // Get the control point magnitudes
    getLineControl, function (_ref2, control) {
        var startEdgeOrigin = _ref2.startEdgeOrigin,
            startConnectionRect = _ref2.startConnectionRect,
            endEdgeOrigin = _ref2.endEdgeOrigin,
            endConnectionRect = _ref2.endConnectionRect;

        // Find the control point
        var controlPoint = getControlPosition({ start: startEdgeOrigin, end: endEdgeOrigin, control: control });

        return (0, _lineUtil.getLinePointsOfInterest)({
            startEdgeOrigin: startEdgeOrigin,
            startConnectionRect: startConnectionRect,
            endEdgeOrigin: endEdgeOrigin,
            endConnectionRect: endConnectionRect,
            controlPoint: controlPoint
        });
    });
};

var getLineStartStyle = exports.getLineStartStyle = function getLineStartStyle(state, ownProps) {
    return (0, _elementSelector.getElement)(state, ownProps).getIn(['content', 'startStyle']);
};

var getLineEndStyle = exports.getLineEndStyle = function getLineEndStyle(state, ownProps) {
    return (0, _elementSelector.getElement)(state, ownProps).getIn(['content', 'endStyle']);
};

var getIsLineStartSnapped = exports.getIsLineStartSnapped = function getIsLineStartSnapped(state, ownProps) {
    return (0, _elementSelector.getElement)(state, ownProps).getIn(['content', 'start', 'snapped']);
};

var getIsLineEndSnapped = exports.getIsLineEndSnapped = function getIsLineEndSnapped(state, ownProps) {
    return (0, _elementSelector.getElement)(state, ownProps).getIn(['content', 'end', 'snapped']);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/lineSelector.js
// module id = 232
// module chunks = 0